export enum UpdateOrganizationDetailsStepTypes {
    UPDATE_ORG_DETAILS = 'UPDATE_ORG_DETAILS',
    UPDATE_CORPORATE_LOGIN_SERVICE_DETAILS_ASSOCIATED = 'UPDATE_CORPORATE_LOGIN_SERVICE_DETAILS_ASSOCIATED',
    DEPLOY_CORPORATE_LOGIN_SERVICE_DETAILS_ASSOCIATED = 'DEPLOY_CORPORATE_LOGIN_SERVICE_DETAILS_ASSOCIATED',
    UPDATE_ORGANIZATION_USERS_CREDENTIALS = 'UPDATE_ORGANIZATION_USERS_CREDENTIALS'
}